export const priceFormatter = new Intl.NumberFormat('th-TH', {
  style: 'currency',
  currency: 'THB'
})

export const formatDate = (date) => new Date(date).toLocaleDateString('th-TH')

export const addCommas = (string) => string.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
